<template>
  <div class="pricing-area pb-75">
    <div class="container mw-1356">
      <div
        class="section-title mw-860 m-auto text-center"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="100"
      >
        <span class="top-title">خطط الأسعار</span>
        <h2>باقات اشتراك مرنة ومناسبة لاحتياجاتك</h2>
      </div>
      <ul
        class="nav nav-tabs justify-content-center pricing-tabs"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="200"
      >
        <li class="nav-item">
          <button
            class="nav-link"
            :class="['tab', { active: activeTab === 'internet' }]"
            @click="setActiveTab('internet')"
          >
            الباقات القياسية (جهاز واحد)
          </button>
        </li>
        <li class="nav-item">
          <button
            class="nav-link"
            :class="['tab', { active: activeTab === 'tv' }]"
            @click="setActiveTab('tv')"
          >
            الباقات العائلية (جهازين)
          </button>
        </li>
        <li class="nav-item">
          <button
            class="nav-link"
            :class="['tab', { active: activeTab === 'homeSecurity' }]"
            @click="setActiveTab('homeSecurity')"
          >
            باقات VIP / الشركاء
          </button>
        </li>
      </ul>

      <div class="tab-content">
        <div v-show="activeTab === 'internet'">
          <div class="row justify-content-center">
            <div
              class="col-xl-4 col-md-6"
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay="200"
            >
              <div class="pricing-single-item">
                <span class="ignite d-block"
                  >التفعيل فوري خلال دقائق بعد الدفع</span
                >
                <div class="pricing-content">
                  <img src="@/assets/images/pricing-1.png" alt="pricing" />
                  <h3>اشتراك 3 أشهر</h3>
                  <p>
                    الخيار المثالي للتجربة المبدئية. قنوات مباشرة + مكتبة الأفلام والمسلسلات بالكامل بدون أي قيود.
                  </p>
                  <div
                    class="d-flex justify-content-between align-items-center speed-mbps"
                  >
                    <div class="download">
                      <span class="speed">الجودة المدعومة</span>
                      <span class="mbps"><span>FHD / 4K</span></span>
                    </div>
                    <div class="download">
                      <span class="speed">الإنترنت الموصى به</span>
                      <span class="mbps"><span>+20</span> Mbps</span>
                    </div>
                  </div>
                  <span class="unlimited">تحديثات يومية مجانية للمحتوى</span>
                  <h2>25<sub> يورو</sub></h2>
                  <a href="https://wa.me/447429916178" target="_blank" class="btn active">
                    <span class="border-style">اشترك الآن عبر الواتساب</span>
                  </a>
                </div>
              </div>
            </div>
            <div
              class="col-xl-4 col-md-6"
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay="300"
            >
              <div class="pricing-single-item">
                <span class="ignite d-block"
                  >الباقة الأكثر طلباً للمغتربين</span
                >
                <div class="pricing-content">
                  <img src="@/assets/images/pricing-2.png" alt="pricing" />
                  <h3>اشتراك 6 أشهر</h3>
                  <p>
                    توفير ممتاز وثبات تام ومقاومة كاملة للحظر في ألمانيا وأوروبا طوال فترة الاشتراك.
                  </p>
                  <div
                    class="d-flex justify-content-between align-items-center speed-mbps"
                  >
                    <div class="download">
                      <span class="speed">الجودة المدعومة</span>
                      <span class="mbps"><span>Ultra HD / 4K</span></span>
                    </div>
                    <div class="download">
                      <span class="speed">الإنترنت الموصى به</span>
                      <span class="mbps"><span>+20</span> Mbps</span>
                    </div>
                  </div>
                  <span class="unlimited">دعم فني متواصل 24/7</span>
                  <h2>45<sub> يورو</sub></h2>
                  <a href="https://wa.me/447429916178" target="_blank" class="btn active">
                    <span class="border-style">اشترك الآن عبر الواتساب</span>
                  </a>
                </div>
              </div>
            </div>
            <div
              class="col-xl-4 col-md-6"
              data-aos="fade-up"
              data-aos-duration="1000"
              data-aos-delay="400"
            >
              <div class="pricing-single-item">
                <span class="ignite d-block"
                  >أكبر توفير - قيمتها الأفضل لعائلتك</span
                >
                <div class="pricing-content">
                  <img src="@/assets/images/pricing-3.png" alt="pricing" />
                  <h3>اشتراك 12 شهراً</h3>
                  <p>
                    سنة كاملة من الترفيه المتواصل بدون تقطيع والمتابعة المستقرة لجميع المباريات والبطولات الكبرى.
                  </p>
                  <div
                    class="d-flex justify-content-between align-items-center speed-mbps"
                  >
                    <div class="download">
                      <span class="speed">الجودة المدعومة</span>
                      <span class="mbps"><span>VIP 4K / 8K</span></span>
                    </div>
                    <div class="download">
                      <span class="speed">الإنترنت الموصى به</span>
                      <span class="mbps"><span>+20</span> Mbps</span>
                    </div>
                  </div>
                  <span class="unlimited">ضمان كامل طوال فترة الاشتراك</span>
                  <h2>70<sub> يورو</sub></h2>
                  <a href="https://wa.me/447429916178" target="_blank" class="btn active">
                    <span class="border-style">اشترك الآن عبر الواتساب</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-show="activeTab === 'tv'">
          <div class="row justify-content-center">
            <div class="col-xl-4 col-md-6">
              <div class="pricing-single-item">
                <span class="ignite d-block"
                  >تشغيل شاشتين معاً في نفس الوقت</span
                >
                <div class="pricing-content">
                  <img src="@/assets/images/pricing-1.png" alt="pricing" />
                  <h3>عائلي 3 أشهر</h3>
                  <p>
                    باقة مخصصة لتشغيل جهازين منفصلين تماماً وبث قنوات مختلفة في نفس اللحظة بأعلى ثبات.
                  </p>
                  <div
                    class="d-flex justify-content-between align-items-center speed-mbps"
                  >
                    <div class="download">
                      <span class="speed">الجودة المدعومة</span>
                      <span class="mbps"><span>FHD / 4K</span></span>
                    </div>
                    <div class="download">
                      <span class="speed">عدد الأجهزة المشغلة</span>
                      <span class="mbps"><span>2</span> جهاز معاً</span>
                    </div>
                  </div>
                  <span class="unlimited">تحديثات يومية وتلقائية للقروبات</span>
                  <h2>40<sub> يورو</sub></h2>
                  <a href="https://wa.me/447429916178" target="_blank" class="btn active">
                    <span class="border-style">اشترك الآن عبر الواتساب</span>
                  </a>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-md-6">
              <div class="pricing-single-item">
                <span class="ignite d-block"
                  >التوفير العائلي الذكي لنصف سنة</span
                >
                <div class="pricing-content">
                  <img src="@/assets/images/pricing-2.png" alt="pricing" />
                  <h3>عائلي 6 أشهر</h3>
                  <p>
                    وفر الكثير وشغّل شاشتك وهاتفك أو جهازين في غرفتين مختلفتين للبث المباشر والأفلام معاً.
                  </p>
                  <div
                    class="d-flex justify-content-between align-items-center speed-mbps"
                  >
                    <div class="download">
                      <span class="speed">الجودة المدعومة</span>
                      <span class="mbps"><span>Ultra HD / 4K</span></span>
                    </div>
                    <div class="download">
                      <span class="speed">عدد الأجهزة المشغلة</span>
                      <span class="mbps"><span>2</span> جهاز معاً</span>
                    </div>
                  </div>
                  <span class="unlimited">سيرفرات أوروبية محمية ومقاومة للحظر</span>
                  <h2>70<sub> يورو</sub></h2>
                  <a href="https://wa.me/447429916178" target="_blank" class="btn active">
                    <span class="border-style">اشترك الآن عبر الواتساب</span>
                  </a>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-md-6">
              <div class="pricing-single-item">
                <span class="ignite d-block"
                  >الباقة العائلية الكبرى والأكثر توفيراً</span
                >
                <div class="pricing-content">
                  <img src="@/assets/images/pricing-3.png" alt="pricing" />
                  <h3>عائلي 12 شهراً</h3>
                  <p>
                    سنة كاملة لجهازين معاً. استقرار كامل، تحديثات يومية للمسلسلات والأفلام، ومتابعة فائقة الجودة.
                  </p>
                  <div
                    class="d-flex justify-content-between align-items-center speed-mbps"
                  >
                    <div class="download">
                      <span class="speed">الجودة المدعومة</span>
                      <span class="mbps"><span>VIP 4K / 8K</span></span>
                    </div>
                    <div class="download">
                      <span class="speed">عدد الأجهزة المشغلة</span>
                      <span class="mbps"><span>2</span> جهاز معاً</span>
                    </div>
                  </div>
                  <span class="unlimited">ضمان ذهبي ممتد طوال العام</span>
                  <h2>110<sub> يورو</sub></h2>
                  <a href="https://wa.me/447429916178" target="_blank" class="btn active">
                    <span class="border-style">اشترك الآن عبر الواتساب</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-show="activeTab === 'homeSecurity'">
          <div class="row justify-content-center">
            <div class="col-xl-4 col-md-6">
              <div class="pricing-single-item">
                <span class="ignite d-block"
                  >باقة مخصصة لأكثر من 3 أجهزة</span
                >
                <div class="pricing-content">
                  <img src="@/assets/images/pricing-1.png" alt="pricing" />
                  <h3>باقة VIP المخصصة</h3>
                  <p>
                    هل تبحث عن تشغيل الخدمة على 3 أجهزة أو أكثر؟ تواصل معنا لنقوم بإنشاء خطة مخصصة تلبي احتياجات منزلك.
                  </p>
                  <div
                    class="d-flex justify-content-between align-items-center speed-mbps"
                  >
                    <div class="download">
                      <span class="speed">الجودة المدعومة</span>
                      <span class="mbps"><span>تخصيص كامل</span></span>
                    </div>
                    <div class="download">
                      <span class="speed">لوحة تحكم خاصة</span>
                      <span class="mbps"><span>مدعومة</span></span>
                    </div>
                  </div>
                  <span class="unlimited">ميزات حصرية وسيرفرات فائقة القوة</span>
                  <h2>حسب الطلب</h2>
                  <a href="https://wa.me/447429916178" target="_blank" class="btn active">
                    <span class="border-style">تواصل معنا للتفاصيل</span>
                  </a>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-md-6">
              <div class="pricing-single-item">
                <span class="ignite d-block"
                  >بنية تحتية مخصصة ومحمية بالكامل</span
                >
                <div class="pricing-content">
                  <img src="@/assets/images/pricing-2.png" alt="pricing" />
                  <h3>باقة سيرفر VIP الخاص</h3>
                  <p>
                    باقة فريدة تمنحك اتصالاً عبر خوادم خاصة لضمان ثبات مطلق وخارق بنسبة 100% أثناء ذروة المباريات العالمية.
                  </p>
                  <div
                    class="d-flex justify-content-between align-items-center speed-mbps"
                  >
                    <div class="download">
                      <span class="speed">نوع الاتصال</span>
                      <span class="mbps"><span>خادم مخصص</span></span>
                    </div>
                    <div class="download">
                      <span class="speed">معدل الثبات</span>
                      <span class="mbps"><span>100%</span> ثابت</span>
                    </div>
                  </div>
                  <span class="unlimited">حماية متطورة مخصصة لأوروبا</span>
                  <h2>حسب الطلب</h2>
                  <a href="https://wa.me/447429916178" target="_blank" class="btn active">
                    <span class="border-style">استفسر الآن</span>
                  </a>
                </div>
              </div>
            </div>
            <div class="col-xl-4 col-md-6">
              <div class="pricing-single-item">
                <span class="ignite d-block"
                  >ابدأ مشروعك الخاص كـ موزع معتمد</span
                >
                <div class="pricing-content">
                  <img src="@/assets/images/pricing-3.png" alt="pricing" />
                  <h3>لوحة موزع (Reseller)</h3>
                  <p>
                    احصل على لوحة تحكم خاصة بك لبيع الاشتراكات في ألمانيا وأوروبا، وابدأ في تحقيق أرباح ممتازة بدعمنا الكامل.
                  </p>
                  <div
                    class="d-flex justify-content-between align-items-center speed-mbps"
                  >
                    <div class="download">
                      <span class="speed">نوع الخدمة</span>
                      <span class="mbps"><span>لوحة موزعين</span></span>
                    </div>
                    <div class="download">
                      <span class="speed">الدعم الفني للموزع</span>
                      <span class="mbps"><span>شامل وخاص</span></span>
                    </div>
                  </div>
                  <span class="unlimited">أسعار تنافسية جداً للائتمان (Credits)</span>
                  <h2>أسعار خاصة</h2>
                  <a href="https://wa.me/447429916178" target="_blank" class="btn active">
                    <span class="border-style">كن موزعاً معنا الآن</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "PricingPlans",
  setup() {
    const activeTab = ref("internet");

    const setActiveTab = (tab: string) => {
      activeTab.value = tab;
    };

    return {
      activeTab,
      setActiveTab,
    };
  },
});
</script>